<template>
  <div class="about">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-btn color="accent" @click="showAddUserDialog">Add User</v-btn>
        </v-flex>
        <v-spacer></v-spacer>

        <!-- table -->
        <v-flex lg12>
          <v-data-table :headers="headers" :items="userData" class="elevation-1" :loading="loading">
            <template v-slot:no-data>
              <v-alert :value="true" color="error" icon="warning">Sorry, nothing to display here :(</v-alert>
            </template>
            <template v-slot:items="props">
              <td class="text-xs-center">{{ props.item.userName }}</td>
              <td class="text-xs-center">{{ props.item.mobileNumber }}</td>
              <td class="text-xs-center">{{ props.item.userType }}</td>
              <td class="text-xs-center">{{ props.item.city }}</td>
              <td class="text-xs-center">{{ props.item.branch }}</td>
              <td class="justify-center layout px-0">
                <v-icon small @click="editItem(props.item)" class="mr-2">edit</v-icon>
                <v-icon small @click="deleteItem(props.item)">delete</v-icon>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Add and Edit User dialog -->
    <v-dialog v-model="dialog" scrollable persistent width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{dialogTitle}}</v-card-title>

        <v-card-text>
          <div id="surveyContainer">
            <survey :survey="addUserSurveyJson"></survey>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeForm">Close</v-btn>
          <v-btn color="primary" v-if="dialogMode == 'ADD'" flat @click="saveForm">Add</v-btn>
          <v-btn color="primary" v-if="dialogMode == 'EDIT'" flat @click="updateForm">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import config from "../config.js";
import * as SurveyVue from "survey-vue";
import "bootstrap/dist/css/bootstrap.css";

var Survey = SurveyVue.Survey;
Survey.cssType = "material";

//Survey.StylesManager.applyTheme("bootstrap");

//If you want to add custom widgets package
//Add these imports
import * as widgets from "surveyjs-widgets";
import "inputmask/dist/inputmask/phone-codes/phone.js";
//And initialize widgets you are want ti use
widgets.icheck(SurveyVue);
widgets.select2(SurveyVue);
widgets.inputmask(SurveyVue);
widgets.jquerybarrating(SurveyVue);
widgets.jqueryuidatepicker(SurveyVue);
widgets.nouislider(SurveyVue);
widgets.select2tagbox(SurveyVue);
widgets.signaturepad(SurveyVue);
widgets.sortablejs(SurveyVue);
widgets.ckeditor(SurveyVue);
widgets.autocomplete(SurveyVue);
widgets.bootstrapslider(SurveyVue);

const serverHost = config.backendServerHost;

var addUserjson = {
 "pages": [
  {
   "name": "page1",
   "elements": [
    {
     "type": "text",
     "name": "loginId",
     "title": "Login Id",
     "isRequired": true
    },
    {
     "type": "text",
     "name": "userName",
     "title": "user name",
     "valueName": "userName",
     "isRequired": true
    },
    {
     "type": "text",
     "name": "password",
     "inputType": "password"
    },
    {
     "type": "text",
     "name": "confirm password",
     "valueName": "confirmPassword",
     "validators": [
      {
       "type": "expression",
       "text": "password do not match",
       "expression": "{password} = {confirmPassword}"
      }
     ],
     "inputType": "password"
    },
    {
     "type": "text",
     "name": "state",
     "isRequired": true
    },
    {
     "type": "text",
     "name": "city",
     "isRequired": true
    },
    {
     "type": "text",
     "name": "branch",
     "isRequired": true
    },
    {
     "type": "dropdown",
     "name": "country",
     "defaultValue": "India",
     "choices": [
      {
       "value": "India",
       "text": "India"
      }
     ]
    },
    {
     "type": "text",
     "name": "email",
     "validators": [
      {
       "type": "email"
      }
     ],
     "inputType": "email"
    },
    {
     "type": "text",
     "name": "mobileNumber",
     "inputType": "number"
    },
    {
     "type": "dropdown",
     "name": "userType",
     "title": "user type",
     "isRequired": true,
     "choices": [
      {
       "value": "admin",
       "text": "admin"
      },
      {
       "value": "manager",
       "text": "manager"
      },
      {
       "value": "feild engineer",
       "text": "feild engineer"
      }
     ]
    }
   ]
  }
 ]
};
var adduserModel = new SurveyVue.Model(addUserjson);
adduserModel.showNavigationButtons = false; //hide navigation
adduserModel.completedHtml="Saving the data";

export default {
  components: {
    Survey
  },
  mounted() {
    this.loadData();
    adduserModel.onComplete.add(this.surveyOnComplete);
  },
  data() {
    return {
      dialogMode: "",
      dialog: false,
      dialogTitle: "",
      form: {
        userName: "",
        mobileNumber: "",
        password: "",
        confirmPassword: "",
        city: "",
        branch: "",
        userType: "",
        email: ""
      },
      items: ["admin", "manager", "feild executive"],

      loading: true,
      headers: [
        {
          text: "user name",
          align: "center",
          sortable: false,
          value: "userName"
        },
        { text: "mobile", align: "center", value: "mobileNumber" },
        { text: "user type", align: "center", value: "userType" },
        { text: "city", align: "center", value: "city" },
        { text: "branch", align: "center", value: "branch" },
        { text: "Actions", align: "center", value: "action", sortable: false }
      ],
      userData: [],
      addUserSurveyJson: adduserModel
    };
  },
  methods: {
    showAddUserDialog() {
      this.dialogTitle = "Add user";
      this.dialogMode = "ADD";
      this.dialog = true;
    },

    saveDataToServer(value) {
      console.log("saving to server :"+JSON.stringify(value)); // someValue
      //alert(JSON.stringify(value));
      //send request

      this.$axios
        .post(serverHost + "/users/insert", value)
        .then(response => {
          console.log(response);
          if (response.status == 200) {
            //parse if status is success or not
            if (Array.isArray(response.data)) {
              this.userData.push(response.data[0]);
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    updateDataToServer(value) {
      this.$axios
        .post(serverHost + "/users/update", value)
        .then(response => {
          console.log(response);
          if (response.status == 200) {
            //parse if status is success or not
            if (response.data.status == "success") {
              this.loadData();
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    deleteItem(value) {
      //this.userData.(value);

      if (confirm("do you want to delete user ?")) {
        this.$axios
          .get(serverHost + "/users/delete/" + value["id"])
          .then(response => {
            // handle success
            console.log(response);
            if (response.status == 200) {
              this.loadData();
            }
          })
          .catch(error => {
            // handle error
            console.log(error);
          })
          .then(() => {
            // always executed
            //this.loading=true;
          });
      }
    },

    editItem(value) {
      this.dialogTitle = "Edit user";
      this.dialogMode = "EDIT";
      var tmpValues = JSON.parse(JSON.stringify(value)); //clone object

      //hack the values set password to "" since confirm password will show error
      delete tmpValues.password;
      delete tmpValues.confirmPassword;

      adduserModel.data = tmpValues;
      this.dialog = true;
    },

    closeForm: function() {
      //this.saveData(this.form);
      this.dialog = false;
      this.form = {};
      adduserModel.clear();
    },

    saveForm: function() {
      // The view model.
      // var vm = this;
      adduserModel.completeLastPage();

      // this.saveDataToServer(this.form);
      // this.form = {};
    },

    surveyOnComplete(result) {
      console.log("result " + JSON.stringify(result.data));
      this.dialog = false;
      

      //save or update the data
      if(this.dialogMode == "EDIT")
      {
        this.updateDataToServer(result.data);
      }
      if(this.dialogMode == "ADD")
      {
        this.saveDataToServer(result.data);
      }
      adduserModel.clear();

    },

    updateForm() {
      // this.updateDataToServer(this.form);
      // this.dialog = false;
      // this.form = {};

      adduserModel.completeLastPage();
    },

    loadData() {
      // Make a request for a user with a given ID
      this.$axios
        .get(serverHost + "/users/get/0")
        .then(response => {
          // handle success
          this.userData = [];
          console.log(response);
          for (var i = 0; i < response.data.data.length; i++) {
            this.userData.push(response.data.data[i]);
          }

          this.loading = false;
        })
        .catch(error => {
          // handle error
          console.log(error);
        })
        .then(() => {
          // always executed
          //this.loading=true;
        });
    }
  }
};
</script>
